export default __webpack_public_path__ + "static/media/information-bg.8742f946.jpg";